import React from "react";
import { Link } from "react-router-dom";
import CTABanner from "../components/CTABanner";
import EraseMyData from "../components/EraseMyData";
import { RETENTION_SCHEDULE, GOV_COMPANY } from "../data/governance";

const DataRetention = () => {
  return (
    <>
      <section className="ek-gradient-dark text-white relative overflow-hidden">
        <div className="ek-star-watermark" />
        <div className="ek-container relative z-10 py-20 md:py-28">
          <div className="ek-eyebrow text-[#A179FA]">Governance</div>
          <h1 className="ek-heading text-4xl md:text-5xl lg:text-6xl text-white mt-4 max-w-4xl leading-tight" data-testid="data-retention-headline">
            Data Retention &amp; Erasure
          </h1>
          <p className="text-zinc-200 font-light text-lg mt-6 max-w-3xl">
            How long {GOV_COMPANY.legalName} keeps each category of data, the lawful basis for doing so, and how to have your data erased — written for procurement and data-protection reviewers.
          </p>
        </div>
      </section>

      <section className="bg-white py-16 md:py-20">
        <div className="ek-container max-w-4xl">
          <div className="ek-body text-[16.5px] space-y-4">
            <p>
              {GOV_COMPANY.legalName} (company no. {GOV_COMPANY.companyNumber}) processes personal data in accordance with {GOV_COMPANY.jurisdiction}. We retain personal data only for as long as necessary for the purposes set out below, after which it is securely deleted or anonymised.
            </p>
          </div>

          <div className="mt-10">
            <h2 className="ek-heading text-2xl md:text-3xl text-black mb-4">Retention schedule</h2>
            <div className="overflow-x-auto border border-zinc-200" data-testid="retention-table">
              <table className="min-w-full text-[14.5px]">
                <thead className="bg-zinc-50 text-left text-zinc-500 text-[11px] uppercase tracking-[0.12em]">
                  <tr>
                    <th className="p-3">Data category</th>
                    <th className="p-3">Retention period</th>
                    <th className="p-3">Lawful basis</th>
                  </tr>
                </thead>
                <tbody>
                  {RETENTION_SCHEDULE.map((r) => (
                    <tr key={r.category} className="border-t border-zinc-100 align-top">
                      <td className="p-3 font-medium text-zinc-900">{r.category}</td>
                      <td className="p-3 text-zinc-700">{r.period}</td>
                      <td className="p-3 text-zinc-600">{r.basis}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="mt-10">
            <h2 className="ek-heading text-2xl md:text-3xl text-black mb-4">Your rights</h2>
            <div className="ek-body text-[16.5px] space-y-4">
              <p>
                You may exercise your UK GDPR rights — access, rectification, erasure, restriction, portability and objection — at any time by emailing <a href={`mailto:${GOV_COMPANY.contactEmail}`} className="text-[#7737F6] hover:underline">{GOV_COMPANY.contactEmail}</a>. Verified requests relating to identified data are actioned within one month.
              </p>
              <p>
                For the anonymous maturity-assessment data tied to your browser (in-progress drafts and completed lite scores), you can erase everything immediately using the self-service control below — no email required.
              </p>
            </div>
            <EraseMyData />
          </div>

          <div className="mt-10 p-5 border border-zinc-200 bg-zinc-50">
            <p className="ek-body text-[15px]">
              Reviewing us for procurement? See our <Link to="/sub-processors" className="text-[#7737F6] hover:underline font-medium" data-testid="data-retention-subprocessors-link">sub-processor register and DPA summary</Link> for the full list of processors and international-transfer safeguards.
            </p>
          </div>
          <p className="text-zinc-500 text-sm mt-8">Last reviewed June 2026. Items marked [TO CONFIRM] are pending verification.</p>
        </div>
      </section>

      <CTABanner />
    </>
  );
};

export default DataRetention;
